import * as actionTypes from '../action/actionTypes';

const initialState = {
  open: false,
  sideBar: true
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.DRAWER_TOGGLE:
      return {
        ...state,
        open: action.data
      };
    case actionTypes.SIDEBAR_TOGGLE:
      return {
        ...state,
        sideBar: action.data
      };
    default:
      return state;
  }
};
export default reducer;
